import { Alert, Stack } from "@mui/material";
import { txt } from "../../../services/translation";

export default function Error(){

    return <Stack direction='row' justifyContent='center'>
        <Alert severity='warning' width='auto'>
            {txt('sectionUnavailable')}
        </Alert>
    </Stack>

}